<div class="page-layout">
  <div class="table-wrapper">
    <!-- Filter bar -->
    <app-material-rates-filters [filterFormGroup]="filterFormGroup" (filtersChanged)="onFiltersChanged($event)">
    </app-material-rates-filters>

    <!-- 🔹 Loading state -->
    @if (loading) {
      <div class="p-32">
        <mc-table
          [data]="loading ? mockDataForLoadingAnimation : data"
          [columns]="columns"
          fit="small"
          nowrap="true"
          headersticky
          height="100%"
          tabularFigures="true">
          @if (loading) {
            @for (row of mockDataForLoadingAnimation; track $index) {
              @for (item of columns; track $index) {
                <div slot="{{ row.id }}_{{ item.id }}">
                  <ngx-skeleton-loader [theme]="{ height: '16px', 'border-radius': '4px' }"></ngx-skeleton-loader>
                </div>
              }
            }
          }
          @if (!loading) {
            @for (row of data; track row) {
              @for (col of columns; track col) {
                <div slot="{{ row.shopCode }}_{{ col.id }}">
                  {{ getValue(row, col.id) }}
                </div>
              }
            }
          }
        </mc-table>
      </div>
    }

    <!-- 🔹 Main data table -->
    @if (!loading && data.length > 0) {
      <div class="table-scrollable">
        <mc-table
          [data]="data"
          [columns]="columns"
          fit="small"
          nowrap="true"
          sortmanual
          (sortchange)="onSortDirectionChange($event)"
          headersticky
          height="100%"
          tabularFigures="true">
          @for (row of data; track row) {
            <div slot="{{ row.id }}_actions" class="action-icon">
              <mc-button
                [hidden]="!row.mreRateNumber"
                padding="compact"
                fit="small"
                hiddenlabel
                icon="arrow-anti-clockwise-clock"
                appearance="primary"
                variant="plain"
                slot="trigger"
                (click)="onAuditLogClicked(row)"
                (keydown.enter)="onAuditLogClicked(row)"
                (keydown.space)="$event.preventDefault(); onAuditLogClicked(row)"></mc-button>
            </div>
          }
        </mc-table>
      </div>
    }

    <!-- 🔹 No Data -->
    <!-- 🔹 No Data -->
    @if (!loading && data.length === 0) {
      <div class="pure-g">
        <div class="pure-u-24-24 m-t-204 flex-container flex-center no-data">
          <span i18n>No Data Found</span>
        </div>
        <div class="pure-u-24-24 m-t-36 flex-container flex-center no-data">
          <span i18n>To widen your search, change or remove filters.</span>
        </div>
        <div class="pure-u-24-24 m-t-36 flex-container flex-center">
          <mc-button
            i18n-label="Button"
            label="Clear all filters"
            variant="filled"
            appearance="primary"
            (click)="clearFilter()"
            fit="medium">
          </mc-button>
        </div>
      </div>
    }

    <!-- 🔹 Pagination -->
    @if (!loading && data.length > 0 && getMaterailRateApiCallStatus === 'COMPLETED') {
      <div class="pagination-footer">
        <app-pagination
          [firstPage]="firstPage"
          [previousPage]="previousPage"
          [currentPage]="currentPage"
          [nextPage]="nextPage"
          [lastPage]="lastPage"
          [totalRecords]="totalRecords"
          [pageLimit]="pageSize"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)">
        </app-pagination>
      </div>
    }
  </div>
</div>

<mc-modal backdropcloseactiondisabled heading="Audit Log" fit="small" dimension="large" [open]="openAuditLog" (closed)="onAuditLogClosed()">
  @if (openAuditLog) {
    <app-master-data-audit-log
      [transactionCode]="selectedMreRateNumber"
      [label]="'Material Rate Number'"
      [auditLogFetcher]="auditLogFetcher">
    </app-master-data-audit-log>
  }
</mc-modal>
